// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34mP3","rootMobile":"styles_rootMobile__bAV_m"};